import React, { useRef, useState } from 'react';
import { DataTitleCopyable } from './data-title';
import { CloseIcon } from '../../components/icons';
/**
 * File picker with a dedicated Upload button (disabled until a file is selected).
 * Upload saves through onUploadSave when provided, otherwise falls back to onChange.
 */
const AttachmentDataEntry = (props) => {
    var _a;
    const inputRef = useRef(null);
    const [pendingNames, setPendingNames] = useState([]);
    const values = (_a = props.value) !== null && _a !== void 0 ? _a : [];
    const isDisabled = props.mode === 'view' || props.disabled;
    const canUpload = !isDisabled && pendingNames.length > 0;
    const onFileSelect = (files) => {
        if (!files || files.length === 0) {
            setPendingNames([]);
            return;
        }
        setPendingNames(Array.from(files).map(f => f.name).filter(Boolean));
    };
    const clearPending = () => {
        setPendingNames([]);
        if (inputRef.current)
            inputRef.current.value = '';
    };
    const handleUpload = (event) => {
        var _a;
        event.preventDefault();
        if (!canUpload)
            return;
        const selectedFiles = ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files)
            ? Array.from(inputRef.current.files)
            : [];
        const merged = Array.from(new Set([...values, ...pendingNames]));
        const nextValue = merged.length ? merged : null;
        if (props.onUploadSave) {
            props.onUploadSave(props.slug, nextValue);
        }
        else if (props.onChange) {
            props.onChange(props.slug, nextValue);
        }
        if (selectedFiles.length && props.onFilesUploaded) {
            props.onFilesUploaded(props.slug, selectedFiles);
        }
        clearPending();
    };
    const remove = (index) => {
        if (!props.onChange)
            return;
        const next = values.slice();
        next.splice(index, 1);
        props.onChange(props.slug, next.length ? next : null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DataTitleCopyable, { slug: props.slug, title: props.title, tooltip: props.tooltip, disabled: props.disabled || values.length === 0, copy: props.copy }),
        React.createElement("p", { className: "data-intro", style: { marginTop: 0, marginBottom: '0.5rem' } }, "Please upload any supporting documents, plans, photos or recordings"),
        !isDisabled && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "input-group", style: { marginBottom: '0.5rem' } },
                React.createElement("input", { ref: inputRef, id: props.slug, type: "file", multiple: true, accept: props.accept, className: "form-control", disabled: isDisabled, onChange: (e) => onFileSelect(e.target.files) })),
            React.createElement("div", { className: "buttons-container with-space", style: { marginBottom: '0.75rem' } },
                React.createElement("button", { type: "button", className: "btn btn-primary", disabled: !canUpload, "aria-disabled": !canUpload, title: canUpload ? 'Upload selected file(s)' : 'Select a file to enable upload', onClick: handleUpload }, "Upload")))),
        values.length === 0 ? (React.createElement("div", { className: "input-group" },
            React.createElement("input", { className: "form-control no-entries", type: "text", value: "No attachments", disabled: true }))) : (React.createElement("ul", { className: "data-entry-list" }, values.map((name, index) => (React.createElement("li", { key: `${name}-${index}`, className: "input-group" },
            React.createElement("input", { className: "form-control", type: "text", value: name, disabled: true }),
            !isDisabled && (React.createElement("div", { className: "input-group-append" },
                React.createElement("button", { type: "button", className: "btn btn-outline-dark", title: "Remove", onClick: () => remove(index) },
                    React.createElement(CloseIcon, null)))))))))));
};
export default AttachmentDataEntry;
